"use strict";
import { quoteRequestTimeoutSignal } from "features/routing/api/quoteRequestTimeout";
const ZERO_X_API_BASE = "https://www.topazdex.com/api/0x";
function buildQueryString(params) {
  const qs = new URLSearchParams({
    chainId: params.chainId.toString(),
    sellToken: params.sellToken,
    buyToken: params.buyToken,
    sellAmount: params.sellAmount
  });
  if (params.taker) {
    qs.set("taker", params.taker);
  }
  if (params.slippageBps !== void 0) {
    qs.set("slippageBps", params.slippageBps.toString());
  }
  return qs.toString();
}
export async function fetch0xPrice(params) {
  const url = `${ZERO_X_API_BASE}?path=swap/allowance-holder/price&${buildQueryString(params)}`;
  const res = await fetch(url, { signal: quoteRequestTimeoutSignal() });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const reason = body?.reason || body?.validationErrors?.[0]?.reason || res.statusText;
    throw new Error(`0x price error: ${reason}`);
  }
  return res.json();
}
export async function fetch0xQuote(params) {
  if (!params.taker) {
    throw new Error("0x /quote requires a taker address");
  }
  const url = `${ZERO_X_API_BASE}?path=swap/allowance-holder/quote&${buildQueryString(params)}`;
  const res = await fetch(url, { signal: quoteRequestTimeoutSignal() });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const reason = body?.reason || body?.validationErrors?.[0]?.reason || res.statusText;
    throw new Error(`0x quote error: ${reason}`);
  }
  return res.json();
}
export const ZERO_X_NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const ZERO_X_ALLOWANCE_HOLDER = "0x0000000000001fF3684f28c67538d4D072C22734";
